import React, { useState } from 'react'

/** ไอคอนซ้ายการ์ดประวัติ: สำเร็จ(เขียว), ไม่อนุมัติ(แดง), รอผล(นาฬิกา), ข้อมูล(น้ำเงิน i) */
export type HistoryCardLeftIcon = 'success' | 'reject' | 'pending' | 'info'

export type HistoryDetailRow = {
  label: string
  value: string
  tone?: 'default' | 'positive' | 'negative' | 'muted'
}

const LEFT_ICON_MAP: Record<HistoryCardLeftIcon, { className: string; icon: string }> = {
  success: { className: 'bg_gd_quaternary', icon: 'fa fa-check ft_sd' },
  reject: { className: 'bg_gd_primary', icon: 'fa fa-times ft_sd' },
  pending: { className: 'bg_gd_tertiary', icon: 'fa fa-clock ft_sd' },
  info: { className: 'bg_gd_tertiary', icon: 'fas fa-info-circle ft_sd' },
}

const TONE_CLASS: Record<NonNullable<HistoryDetailRow['tone']>, string> = {
  default: '',
  positive: 'history-detail-item__value--positive',
  negative: 'history-detail-item__value--negative',
  muted: 'history-detail-item__value--muted',
}

interface HistoryCollapseCardProps {
  id: string
  leftIcon: HistoryCardLeftIcon
  header: React.ReactNode
  refId: string
  rows: HistoryDetailRow[]
  onCopyRef?: () => void
  actionLabel?: string
  onAction?: () => void
  secondaryActionLabel?: string
  onSecondaryAction?: () => void
}

/** การ์ด collapse ใช้ในประวัติฝาก/ถอน/เครดิต/เล่นพนัน — ตรง history.html */
export const HistoryCollapseCard: React.FC<HistoryCollapseCardProps> = ({
  id,
  leftIcon,
  header,
  refId,
  rows,
  onCopyRef,
  actionLabel,
  onAction,
  secondaryActionLabel,
  onSecondaryAction,
}) => {
  const [open, setOpen] = useState(false)
  const left = LEFT_ICON_MAP[leftIcon]
  return (
    <div className="history-collapse-card bg_secondary border_10 bdc_primary ins_sd ft_sd overflow-hidden h-100 cl_wrap">
      <button
        type="button"
        className="history-collapse-card__toggle px-3 px-md-5 py-3 bg_gd_secondary border-0 position-relative w-100 d-flex align-items-center"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-controls={`collapse-${id}`}
      >
        <div
          className={`${left.className} btn_close box_row flex-nowrap justify-content-center c_tertiary p-2 border_30 history-collapse-card__status-icon`}
        >
          <i className={left.icon} />
        </div>
        <div className="h_txt_wrap history-collapse-card__header flex-grow-1 text-start ms-2">
          {header}
        </div>
        <div className="bg_primary btn_close box_row flex-nowrap justify-content-center c_tertiary p-2 border_30 history-collapse-card__expand-icon">
          <span
            className="fw-bold"
            style={{ fontSize: '1.15rem', lineHeight: 1, marginTop: '-1px' }}
            aria-hidden="true"
          >
            {open ? '-' : '+'}
          </span>
        </div>
      </button>
      {open && (
        <div className="history-collapse-card__body card card-body bg-transparent border-0">
          <div className="history-ref-block">
            <div className="history-ref-block__main">
              <span className="history-ref-block__label">เลขที่อ้างอิง</span>
              <span className="history-ref-block__value" title={refId}>
                {refId}
              </span>
            </div>
            <div className="history-ref-block__actions">
              {actionLabel && onAction && (
                <button
                  type="button"
                  className="history-ref-block__btn history-ref-block__btn--primary"
                  onClick={(e) => {
                    e.stopPropagation()
                    onAction()
                  }}
                >
                  <i className="fas fa-search me-1" /> {actionLabel}
                </button>
              )}
              {secondaryActionLabel && onSecondaryAction && (
                <button
                  type="button"
                  className="history-ref-block__btn history-ref-block__btn--accent"
                  onClick={(e) => {
                    e.stopPropagation()
                    onSecondaryAction()
                  }}
                >
                  <i className="fas fa-upload me-1" /> {secondaryActionLabel}
                </button>
              )}
              <button
                type="button"
                className="history-ref-block__btn history-ref-block__btn--ghost"
                onClick={(e) => {
                  e.stopPropagation()
                  onCopyRef?.()
                }}
              >
                <i className="fas fa-copy me-1" /> คัดลอก
              </button>
            </div>
          </div>
          <div className="history-detail-section">
            <h5 className="history-detail-section__title h_txt mb-0">รายละเอียด</h5>
            <dl className="history-detail-list mb-0">
              {rows.map((row, index) => {
                const tone = row.tone || 'default'
                const isLongValue = row.value.length > 72 || row.value.includes('\n')
                return (
                  <div key={`${row.label}-${index}`} className="history-detail-item">
                    <dt className="history-detail-item__label">{row.label}</dt>
                    <dd
                      className={[
                        'history-detail-item__value',
                        TONE_CLASS[tone],
                        isLongValue ? 'history-detail-item__value--long' : '',
                      ]
                        .filter(Boolean)
                        .join(' ')}
                    >
                      {row.value}
                    </dd>
                  </div>
                )
              })}
            </dl>
          </div>
        </div>
      )}
    </div>
  )
}
